import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    propertyList: []
  },

  mutations: {
    ADD_TO_FAVOURITES (state, data) {
      state.propertyList.push(data)
    },

    REMOVE_FROM_FAVOURITES (state, propertyId) {
      var propertyList = _.remove(state.propertyList, function(favourite) {
        return favourite.propertyId !== propertyId
      })

      state.propertyList = propertyList
    }
  },

  getters: {
    favourites: (state) => {
      return state.propertyList
    }
  }
}
